
import React from 'react';
import { Progress } from '@/components/ui/progress';

interface OnboardingProgressProps {
  recipeCount: number;
  totalMealPlansCount: number;
  shoppingListCount: number;
}

const OnboardingProgress: React.FC<OnboardingProgressProps> = ({ 
  recipeCount, 
  totalMealPlansCount,
  shoppingListCount
}) => {
  let progress = 0;
  let completedSteps = 0;
  
  // All counts are now personal counts for progress calculation
  if (recipeCount > 0) {
    completedSteps += 1;
    progress += 33;
  }
  if (totalMealPlansCount > 0) {
    completedSteps += 1;
    progress += 33;
  }
  if (shoppingListCount > 0) {
    completedSteps += 1;
    progress += 34;
  }

  return (
    <div className="max-w-2xl mx-auto mb-4">
      <div className="space-y-2 pt-6">
        <Progress 
          value={progress} 
          className="h-2 bg-golden-light/30"
        />
        <div className="flex justify-between text-xs text-muted-foreground">
          <span className={recipeCount > 0 ? 'text-sage font-medium' : ''}>
            Add Recipes
          </span>
          <span className={totalMealPlansCount > 0 ? 'text-sage font-medium' : ''}>
            Plan Meals
          </span>
          <span className={shoppingListCount > 0 ? 'text-sage font-medium' : ''}>
            Shop the List
          </span>
        </div>
      </div>
    </div>
  );
};

export default OnboardingProgress;
